import * as bootstrap5 from "bootstrap";

export default (toast) => ({
    progress: 100,
    _interval: null,
    _bsToast: null,

    init() {
        const autohide = !this.hasActions() && !toast.modal;

        this._bsToast = new bootstrap5.Toast(this.$el, {
            delay: toast.delay,
            autohide: autohide
        });

        // Progress bar animation
        if (autohide) {
            const step = 50;
            const decrement = (step / toast.delay) * 100;
            this._interval = setInterval(() => {
                this.progress -= decrement;
                if (this.progress <= 0) {
                    clearInterval(this._interval);
                    this._interval = null;
                }
            }, step);
        } else {
            this.progress = 0;
        }

        if (toast.modal) {
            this._addBackdrop();
        }

        // Remove from store when Bootstrap hides the toast
        this.$el.addEventListener('hidden.bs.toast', () => {
            this._removeBackdrop();
            this.$store.messages.removeToast(toast._id);
            if (toast._resolve) {
                toast._resolve(null);
                toast._resolve = null;
            }
        });

        this._bsToast.show();
    },

    hasActions() {
        return toast.actions && toast.actions.length > 0;
    },

    _addBackdrop() {
        if (this._backdrop) return;
        this._backdrop = document.createElement('div');
        this._backdrop.className = 'toast-backdrop';
        Object.assign(this._backdrop.style, { // this is put in style attribute because the element is added in document outside of the Shadow DOM
            position: 'fixed',
            inset: '0',
            background: 'rgba(0, 0, 0, 0.35)',
            zIndex: '1050',
        });
        document.body.appendChild(this._backdrop);
        document.body.classList.add('toast-modal-open');
    },

    _removeBackdrop() {
        if (this._backdrop) {
            this._backdrop.remove();
            this._backdrop = null;
            document.body.classList.remove('toast-modal-open');
        }
    },

    onAction(action) {
        if (action.dismiss !== false) {
            this.close();
        }
        if (toast._resolve) {
            toast._resolve(action.id);
            toast._resolve = null;
        }
    },

    destroy() {
        if (this._interval) clearInterval(this._interval);
        if (this._bsToast) this._bsToast.dispose();
    },

    close() {
        if (this._bsToast) this._bsToast.hide();
        this.$store.messages.removeToast(toast._id);
        this._removeBackdrop();
    },

    progressStyle() {
        return `width: ${this.progress}%; transition: width 50ms linear;`;
    },

    isLightCategory(category) {
        return ['warning', 'light', 'info'].includes(category);
    },

    headerClass(category) {
        return `bg-${category} ${this.isLightCategory(category) ? 'text-dark' : 'text-white'}`;
    },

    closeBtnClass(category) {
        return this.isLightCategory(category) ? 'btn-close' : 'btn-close btn-close-white';
    }
});